import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import ShipownerForm from "../shipownerForm/shipownerForm";


export default class AddShipowner extends React.Component {
    render() {
        return (
            <AddItem
                class="add-shipowner"
                header= {i18n.t("dictionaries.shipowners.actions.addShipowner.header")}
                content={<ShipownerForm isUpdate={false}/>}
            />
        );
    }
}